












































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import isMobileJS from 'ismobilejs'
import { BModal, BCarousel } from 'bootstrap-vue';
import { SheetListCondition, Sheet, CramStudent, Course} from "../../modules/student/SheetList"


export interface Data {
  condition: SheetListCondition
  sheets: Sheet[]
  cram_student: CramStudent
  totalCount: number
  carouselPageIdx: number
  windowHeight: number
  modalSheet: Sheet
  isShow: boolean
  isShowCarousel: boolean
  isTeacherSite: boolean
  base64Pdf: string
  isMobile: boolean
  errors: string[]
  nendos: number[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){
    
    const modalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();
    const modalExplanationRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: new SheetListCondition(),
      sheets: new Array<Sheet>(),
      cram_student: new CramStudent({}),
      totalCount: 0,
      carouselPageIdx: 0,
      windowHeight: 0,
      modalSheet: new Sheet({}),
      isShow: false,
      isShowCarousel: false,
      isTeacherSite: window.location.href.indexOf("teacher_site") != -1,
      base64Pdf: null,
      isMobile: false,
      errors: [],
      nendos: [],
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {

      if(!state.condition.nendo){
        alert("年度を選択してください。");
        return;
      }
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.condition.cram_student_id = context.root.$store.state.cram_student_id;
      await http.get(`/api/student_sheet_list?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.sheets = response.data.sheets.map((x: any) => new Sheet(x));
        state.cram_student = response.data.cram_student;
        state.totalCount = state.sheets.length == 0 ? 0 : state.sheets[0].full_count;
        context.root.$store.commit("setStudentSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      const event_code = state.condition.event_code;
      state.condition = new SheetListCondition();
      state.condition.event_code = event_code;
      state.condition.nendo = Common.getNendo();
      if(event_code != "1"){
        state.condition.month = "";
      }
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 画面リロード
     ******************************/

    const reload = () => {
      location.reload();
    };

    /******************************
     * 成績詳細画面へ
     ******************************/

    const toRanksDetail = (sheet_id: string, cram_student_id: string) => {
      if(context.root.$store.state.currentUser.role == "student"){
        context.root.$router.push(`/student_site/result_rank_detail/${sheet_id}/${context.root.$store.state.cram_student_id}`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/result_rank_detail/${sheet_id}/${context.root.$store.state.cram_student_id}`).catch(err => {});
      }
    };

    /**
     * 戻る処理
     */
    const goBack = (): void => {
        context.root.$router.go(-1);
    };

    /************************************************************
     * 答案画像モーダル表示
     ************************************************************/
    const previewImage = async (sheet_idx: number, student_code: string) => {

      const sheet = state.sheets[sheet_idx];
      if(sheet.base64Images.length == 0){
        context.root.$store.dispatch("showOverlay");
        await http.get(`/api/student_sheet_list/download_image/${sheet.id}/${student_code}`).then(response => {
          response.data.base64_images.forEach((x: string) => {
            state.sheets[sheet_idx].base64Images.push(x);
          });
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
        context.root.$store.dispatch("hideOverlay");
      }
      state.isShowCarousel = true;
      state.carouselPageIdx = 0;
      state.modalSheet = state.sheets[sheet_idx];
      modalRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/
    const carouselPrev = () => {
      carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.modalSheet.page_count - 1;
      }
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/
    const carouselNext = () => {
      carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.modalSheet.page_count){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }
    };

    /******************************
     * 解説PDFダウンロード
     ******************************/

    const downloadExplanationImage = async (sheet: Sheet) => {
      context.root.$store.dispatch("showOverlay");
      
      await http.get(`/api/student_sheet_list/download_explanation_pdf/${sheet.base_sheet_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.target = "_blank"
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      state.windowHeight = windowHeight;
    };

    /******************************
     * 取込日を画面表示文言にコンバート
     ******************************/

    const convertCaptureDate = (date: string) => {
      return date ? moment(date).format('Y年M月D日') : "-";
    };

    /******************************
     * マイページ認証
     ******************************/

    const singIn = async () => {

      // URLを取得
      var url = new URL(window.location.href);

      // URLSearchParamsオブジェクトを取得
      var params = url.searchParams;
      
      const param: object = {
        app_key: params.get("app_key"),
        tmp_id: params.get("tmp_id"),
        tmp_key: params.get("tmp_key"),
        has_key: params.get("has_key"),
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/login/student`, param).then(response => {
        var token = response.data.user.access_token
        document.cookie = 'access_token=' + token;
        document.cookie = 'smarky_user_id=' + response.data.user.id;
        context.root.$store.commit("setCurrentUser", response.data.user);
        context.root.$store.commit("setCramStudentId", response.data.cram_student_id);
        context.root.$store.commit("setCurriculums", response.data.curriculums);
        context.root.$store.commit("setMainteInfo", response.data.mainte_infos);
      })
      .catch(error=>{
        if(error && error.response && error.response.status && error.response.status == 422){
          alert(error.response.data.errors[0]);
        }else{
          alert(`認証に失敗しました。マイページからやり直してください。`);
        }
        window.close();
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 受講講座リスト取得
     ******************************/

    const getCourses = async () => {

      await http.get(`/api/student_sheet_list/get_courses/${context.root.$store.state.cram_student_id}`).then(response => {
        context.root.$store.commit("setEvents", response.data.events);
        if(!context.root.$store.state.event_code){
          context.root.$store.commit("setEventCode", context.root.$store.state.events[0].event_code);
        }
        state.condition.event_code = context.root.$store.state.event_code;
      })
      .catch(error=>{
        if(error && error.response && error.response.status && error.response.status == 422){
          alert(error.response.data.errors[0]);
        }else{
          alert(`認証に失敗しました。マイページからやり直してください。`);
        }
        window.close();
      });

    };

    /******************************
     * イベント切り替え
     ******************************/

    const eventChanged = () => {
      context.root.$store.commit("setEventCode", state.condition.event_code);
      window.location.reload();
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      let isSuperReload = false;
      if(!context.root.$store.state.cram_student_id){
        await http.get("/api/master_data/version").then(async (response) =>{
          const version = response.data.version;
          const cookieVersion = Common.getCookieValue(document.cookie, "smarky_version");
          console.log(`api:${version}, cookie:${cookieVersion}`);
          if(version != cookieVersion){
            document.cookie = 'smarky_version=' + version;
            isSuperReload = true;
            window.location.reload(true);
          }else{
            // 生徒アカウント 初回表示は認証を行う
            await singIn();
          }
        });
      }

      if(isSuperReload){
        return;
      }

      // 検索条件キャッシュロード
      state.condition = context.root.$store.state.studentSheetListCondition;

      await getCourses();

      if(context.root.$store.state.cram_student_id){
        if(isMobileJS(window.navigator).phone || isMobileJS(window.navigator).tablet){
          state.isMobile = true;
        }
        if(context.root.$store.state.event_code != 1){
          state.condition.month = "";
        }

        // 本日日付から年度を取得
        const nendo = Common.getNendo();

        // 年度プルダウンのoption設定
        for(let i = -5; i <= 2; i++){
          state.nendos.push(nendo + i);
        }

        if(!state.condition.nendo){
          // 検索条件.年度未設定の場合、今年度を設定
          state.condition.nendo = nendo;
        }

        await search();
        state.isShow = true;
        adjustHeight();
        window.addEventListener("resize", adjustHeight);
      }
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
    });

    return {
      ...toRefs(state),
      modalRef,
      carouselRef,
      search,
      searchClick,
      clearCondition,
      changePage,
      reload,
      goBack,
      toRanksDetail,
      adjustHeight,
      previewImage,
      carouselPrev,
      carouselNext,
      convertCaptureDate,
      modalExplanationRef,
      downloadExplanationImage,
      eventChanged,
    }
  }
});
